// @unocss-include
import { getRgb } from '@zc-react-admin/color';
import clsx from 'clsx';

import { DARK_CLASS } from '@/constants/app';
import { toggleHtmlClass } from '@/utils/common';
import { localStg } from '@/utils/storage';

const DefaultFallback = memo(() => {
  const themeColor = localStg.get('themeColor') || '#947235';

  const darkMode = localStg.get('darkMode') || false;

  if (darkMode) {
    toggleHtmlClass(DARK_CLASS).add();
  }

  const { b, g, r } = getRgb(themeColor);

  const loadingClasses = [
    'left-0 top-0',
    'left-0 bottom-0 animate-delay-500',
    'right-0 top-0 animate-delay-1000',
    'right-0 bottom-0 animate-delay-1500'
  ];

  return (
    <div
      className="fixed-center flex-col bg-layout"
      style={{ '--primary-color': `${r} ${g} ${b}` } as React.CSSProperties}
    >
      <div className="my-36px h-56px w-56px">
        <div className="relative h-full animate-spin">
          {loadingClasses.map(item => {
            return (
              <div
                className={clsx('absolute h-16px w-16px animate-pulse rounded-8px bg-primary', item)}
                key={item}
              />
            );
          })}
        </div>
      </div>
      <h2 className="text-28px text-primary font-500">{import.meta.env.VITE_APP_TITLE}</h2>
    </div>
  );
});

export default DefaultFallback;
